// Fire registration tracking events after a successful free-trial signup.
//
// Meta Pixel: CompleteRegistration + Lead. The base pixel is loaded by the
// page template (Pixel Manager Pro on the live site, or a plugin-injected
// base snippet when a Meta Pixel ID is configured), so window.fbq should
// already exist here. We also push a GA4-shaped dataLayer event so any GTM
// container on the site can route it to GA4 / TikTok.

import { config } from './config';

interface RegistrationPayload {
    email: string;
    firstName: string;
    lastName: string;
    subjects: string[];
    grade: string;
}

export function trackRegistration(payload: RegistrationPayload): void {
    const contentName = config.contentName;

    try {
        if (typeof window.fbq === 'function') {
            // NOTE: CompleteRegistration is intentionally NOT fired here.
            // Pixel Manager Pro auto-fires it on the WordPress user creation,
            // so firing it again would double-count. The SPA owns Lead only.
            window.fbq('track', 'Lead', {
                content_name: contentName,
                currency: 'USD',
                value: 0,
            });
        }
    } catch {
        // Never let a tracking failure break the success flow.
    }

    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'free_trial_signup',
            method: 'alt-free-trial',
            content_name: contentName,
            grade: payload.grade,
            subjects: payload.subjects,
        });
    } catch {
        // no-op
    }
}
